// extracted by mini-css-extract-plugin
export default {"wrap":"ZH-z","subtitle":"_H-z","contentWrap":"aI-z","imgWrap":"bI-z","heading":"cI-z","copy":"dI-z"};